export default {
  common: {
    add: 'Add',
    read_more: 'expand',
    read_less: 'reduce',
    as_seen_on: 'As seen on',
    more_info: 'More Info',
    required_field: 'Required fields',
    submit: 'Apply',
    reset: 'Reset',
    search: 'Search',
    back: 'Back',
    save_money: 'Save',
    more: 'More',
    more2: 'More',
    next: 'Next',
    oder: 'or',
    spare: 'SAVE',
    load_more: 'Load more',
    close: 'Close',
    here: 'here',
    email: 'Email',
    with: 'With',
    soldout: 'Sold out',
    soldout2: 'Fully booked',
    all_motifs: 'All motifs',
    all: 'All',
    location: 'Location',
    welcome_by_AN: 'Welcome to ArtNight!',
    select_city_content: 'Select your nearest location to directly access available painting courses in your city!',
    later: 'Later',
    city: 'City',
    view_AN: 'View ArtNights',
    remove: 'Remove',
    share_artnight: 'Share this ArtNight',
    save: 'Save',
    save_selection: 'Save selection',
    page: 'Page',
    out_of: 'of',
    code: 'Code',
    give_feedback: 'Give feedback',
    multi_cities: '{cities_count} city | {cities_count} cities'
  },
  online_badge: {
    our: 'Our',
    more: 'More',
    online: 'Online'
  },
  menu: {
    online_team_events: 'Online Team Events',
    team_events: 'Groups & Companies',
    team_events2: 'Group events',
    team_events3: 'Private {brand}s',
    team_events_virtuelle: 'Virtual Team Events',
    bachelorette_party: 'Bachelorette parties',
    about_us: 'About us',
    press: 'Press',
    terms: 'Terms and Conditions',
    impressum: 'Imprint',
    privacy: 'Privacy Policy',
    voucher: 'Voucher',
    gift_voucher: 'Gift voucher',
    subtitle: 'Digital voucher for printing',
    voucher_as_gift: 'Gift a voucher',
    personalised_voucher: 'Personalized voucher',
    giftbox: 'Voucher box',
    ticket_rebooking: 'Ticket rebooking',
    become_artist: 'Become an artist',
    become_acryl_artist: 'Acrylic artist',
    become_handlettering_artist: 'Handlettering artist',
    become_host: 'Become a host',
    become_baker: 'Become a course instructor',
    become_location: 'Become a location',
    help_contact: 'Help & Contact',
    jobs: 'Jobs',
    blog: 'Blog',
    faq: 'FAQ',
    contact: 'Contact',
    at_home: '{brand}s for home',
    livestream: '{brand} Live Stream',
    live_online: 'Online {brand}',
    live_online2: 'Live Online {brand}',
    online_events: 'Online painting course',
    video_tutorials: 'Video courses',
    baking_tutorials: 'Baking courses',
    material_brand: 'Buy {brand} materials',
    material: 'Material',
    email_coach: 'Email Coach: Drawing people'
  },
  errors: {
    general: 'An error has occurred. Please try again.',
    message_404: 'Unfortunately, we cannot find the page you are looking for.'
  },
  category: {
    new_label: 'NEW NOW',
    material_description:
      'With our high-quality materials, nothing stands in the way of letting your creativity run free!',
    live_label: 'Our {type} {brand}s',
    motiv_page_title: 'ArtNight: Painting courses near you',
    city_page_title: 'ArtNight: Painting courses in {city}',
    event_page_title: 'ArtNight: Paint the motif of the {theme} in {city}',
    online_event_page_title: 'ArtNight: Paint the motif of the {theme} Online',
    meta_event_description: 'Paint with us the motif of the {theme} on {date} at {location} in {city}',
    meta_online_event_description: 'Paint with us on {date} the motif of the {theme} online.',
    meta_motiv_description:
      'Choose from a variety of ArtNight motifs and experience painting in over 60 cities. Perfect for a relaxed evening full of creativity!',
    events_page_title: 'Painting courses near you | ArtNight',
    meta_description:
      'Choose from a variety of ArtNight motifs and experience painting in {city}. Perfect for a relaxed evening full of creativity!',
    meta_online_description:
      'Choose from a variety of ArtNight motifs and experience painting comfortably from home. Perfect for a relaxed evening full of creativity!',
    meta_title: 'Painting courses in {city} ',
    live_meta_title: 'ArtNight: Online painting courses for home',
    artnight_live_description:
      'Discover, like at an ArtNight, the fun of painting as an interactive experience live from home!\u2028Our artists guide you step by step through your chosen motif via livestream. You can ask questions at any time and exchange ideas with the other participants. For an Online ArtNight you need a canvas (30x40cm), acrylic paints and brushes. Optionally, you can order the materials directly with your purchase. After completing your purchase, you will receive a link through which you can dial into the ArtNight livestream.',
    search_no_cities: 'There is no city named {query}.',
    search_title: 'Enter city',
    events_in: 'Painting courses in {city}',
    filters: {
      label: 'Filter',
      button_text: 'Filter',
      reset: 'Reset filters',
      empty: 'No results',
      type: {
        regular: 'Regular {brand}',
        regular_text: 'The classic {brand} experience that we are known for.',
        charity: 'Charity {brand}',
        charity_text:
          'At a Charity {brand} you will definitely paint for a good cause! 5% of all proceeds go to a charity organization.',
        small_group: 'Small group {brand}',
        small_group_text:
          'Our small group {brand} allows for more individual attention with a maximum of 15 participants per event.',
        collaboration: 'Collaboration {brand}',
        collaboration_text:
          'In our collaborations, we work with exclusive companies to offer you a unique {brand} experience.'
      },
      skill: {
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Professional'
      },
      sort: {
        standard: 'Standard sorting',
        desc: 'Newest to oldest',
        asc: 'Oldest to newest'
      },
      filter: {
        city: 'City',
        date: 'Date',
        date_placeholder: 'Choose the days that suit you.',
        skill: 'Level',
        type: 'Event Type',
        host: 'Artist',
        theme: 'Motif',
        theme_category: 'Categories',
        sort: 'Sort'
      },
      dayNames: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
    },
    kids_events: {
      title:
        'ArtNight is the perfect painting course for children from 5 years who want to discover their creative side. Our experienced ArtNight artists introduce children to the world of colors and shapes and support them in developing their own artistic skills.',
      subtitle:
        'Through painting and designing, children learn to express their thoughts and feelings and to better focus on a task.',
      meta: {
        title: 'Joint painting courses for children and parents | ArtNight',
        description: 'Paint two great pictures with your child and take your artwork home as a beautiful memory!'
      }
    },
    discovery_banner: {
      title: 'Painting courses for groups and companies',
      text: 'The most creative team event for any occasion!',
      button: 'More information and appointment request'
    }
  },
  voucher: {
    seo: {
      title: 'ArtNight: Buy a voucher to gift creativity',
      description:
        'Treat yourself or a loved one to an ArtNight experience. Redeemable for any ArtNight painting course in over 60 cities or online.'
    },
    price_explainers: {
      0: '1 Online Ticket',
      1: '1 On-site Ticket',
      2: '2 ArtNight Kids Tickets',
      3: '2 On-site Tickets',
      4: '10 x Online Tickets',
      5: '10 x ArtNight on-site',
      6: 'test'
    },
    voucher: 'Voucher',
    digital: 'Digital voucher',
    physischer: 'Physical voucher',
    multiticket: 'Multiticket',
    hero_title: 'A {brand} voucher is the perfect gift!',
    discount: 'Offer!',
    discount_title: '12 tickets for the price of 10',
    discount_text:
      'When purchasing our annual card for ArtNight events on-site or online, get 12 tickets for the price of just 10. The two free tickets will be sent to you as discount codes by email.',
    product_options: {
      header: 'Greeting message',
      voucher: 'Greeting message'
    },
    delivery_text: 'We will send you the voucher by email immediately after purchase.',
    multitickets: 'Multitickets',
    choose_amount: 'Choose the amount',
    choose_motive: 'Choose a voucher design',
    choose_message: 'Personalize your voucher with a greeting message',
    write_message: 'Write your own text',
    write_message_placeholder: 'Write greeting message...',
    characters_left: 'characters left',
    usability_warning: 'Gift vouchers can be redeemed for all products except for additional gift vouchers.',
    artnight: {
      listing_hero_headline: 'For all those who want to gift creativity.',
      grid_title: 'Discover more <br>{brand} vouchers',
      listing_hero_content: 'With our ArtNight vouchers, everyone discovers their creative side – the perfect gift!',
      listing_hero_list_items: [
        'An unforgettable experience in community - because spending creative time together is one of the most valuable things.',
        'Individual and unique - in the end, everyone has their own creation to give away or to decorate their own home.',
        'The all-inclusive package - our artists bring everything and guide you step by step to the goal.'
      ],
      voucher_personalisation_options: [
        {
          name: 'Birthday',
          text: 'Happy Birthday! Treat yourself to a creative break at an ArtNight.'
        },
        {
          name: "Mother's Day",
          text: "Dear Mom, I wish you all the best for Mother's Day! You deserve a little creative break."
        },
        {
          name: 'Christmas',
          text: 'Merry Christmas! Have fun taking a creative break at an ArtNight.'
        },
        {
          name: 'Thank You',
          text: 'A little thank you for you! You deserve a creative break.'
        },
        {
          name: 'For Colleagues',
          text: 'Thank you for the great collaboration - we think you deserve a creative break at an ArtNight.'
        },
        {
          name: "Valentine's Day 💖",
          text: "Happy Valentine's Day! You are something special and deserve a creative break at an ArtNight."
        },
        {
          name: 'Blank',
          text: ' '
        }
      ],
      hero_text: 'Time for the perfect gift!',
      giftcard_text:
        'Choose a suitable amount for your voucher and personalize it as you like with a motif and a personal greeting message.',
      multiticket_text:
        'Multitickets contain multiple voucher codes with a value of {unitPrice} € each. The larger the multiticket, the more you save!'
    },
    personalise: 'Personalize your gift voucher',
    amount: 'Choose an amount',
    amount_subtitle: 'The selected voucher value can be redeemed for all ArtNight painting courses',
    headline: 'How would you like to receive the voucher?',
    design: 'Choose a design for your voucher',
    receive: 'Who will be gifted?',
    message: 'Add a message',
    emoji_message: 'Emojis will not be displayed',
    sending_option_title: 'Gift card option',
    sending_option_subtitle: 'Choose between a digital or physical voucher',
    sending_options: {
      pdf: {
        title: 'Digital voucher',
        subtitle: 'Print at home',
        asterisk: '<b>+ 8 €</b>'
      },
      card: {
        title: 'Physical voucher',
        subtitle: 'Shipping within DE/AT'
      }
    },
    personalised_msg_title: 'Add a message',
    personalised_msg_subtitle: 'Write a personal message (optional)',
    text_area_subtitle: '{number} characters left',
    summary_title: 'Done!',
    summary_subtitle: 'Your personalized gift card:',
    value: 'Value:',
    option: 'Option:',
    message_summary: 'Message:',
    image_legend_pdf: {
      title: 'Digital voucher',
      subtitle: 'For immediate printing'
    },
    image_legend_physical: {
      title: 'Physical voucher',
      subtitle: 'Unique: With elegant hand-painted art envelope'
    }
  },
  event: {
    find_your_artnight: 'Find your ArtNight',
    copyright_image: 'Source of the example image: {content}',
    copyright_theme: 'Source of the motif: {content}',
    theme_included_title: "What's included",
    theme_learnings_title: 'What you will learn',
    livestream_from: 'Live from {city}',
    online_text: 'Online ArtNight',
    outdoor_text: '{brand} outdoors',
    collaboration_text: 'Collaboration',
    collaboration_with_text: 'Collaboration with {name}',
    select_date_text: 'Please select a date',
    more_events_text: 'More dates',
    upsell_header_text: 'Goes well with',
    sales_stopped_text: 'Sales closed',
    time_text: "{start} - {end} o'clock",
    reviews_title: 'Reviews',
    sold_out_text: 'Sold out',
    ticket_qty_text: '{qty} ticket | {qty} tickets',
    last_chance_text: 'Only {qty} ticket left! | Only {qty} tickets left!',
    artnight_meta_title: 'On {date} at {time}, {host} will paint the motif {theme} with you',
    about_materials_title: 'The materials',
    about_bundle_title: 'About this bundle',
    price_message: 'Part',
    two_days_event: '2-part event',
    select_date: 'Select date',
    select_date_empty_state_with_city_text:
      "Sorry, we currently don't offer any more events with this motif in { city }.",
    select_date_empty_state_text: "Sorry, we currently don't offer any more events with this motif.",
    select_city: 'Select city',
    price_per_ticket: 'Price per ticket',
    features: {
      title: 'The most important information upfront',
      basic_level: 'Beginner level',
      pro_level: 'Advanced level',
      advanced_level: 'Professional',
      materials: {
        shipment: 'Materials to your home',
        purchase: 'Order our material set',
        more_info: 'More material information can be found here'
      },
      materials_included: 'All materials included',
      materials_not_included:
        '<a href="https://help.artnight.com/hc/de/articles/12455852875036-Was-ist-eine-Online-ArtNight" target="blank" class="cl-primary ff-bold">More material information can be found here</a>',
      painting_info: 'Motif can be painted with acrylic, water or food coloring',
      material_set: `We'd be happy to send our ArtNight material to your home: <a href="/products/artnight-acryl-material-kit/" class="cl- primary ff- bold">Order our material set</a>`,
      with_recipe: 'Including recipe & shopping list',
      host: 'With {host}',
      fun: 'Carefree fun.',
      corona_notice: 'Our concept for the safety of our participants',
      video_course: 'Paint at your own pace, when and where you want',
      livestream_text:
        "For the perfect preparation, you'll receive two video courses from us for free: Brush technique \uD83D\uDD8C and Color theory \uD83C\uDFA8.",
      duration_text: '<strong>Duration</strong>: approx. {min} min',
      preparation_text: '<strong>Preparation time</strong>: {min} min',
      language_text: 'Language: {languages}',
      languages: {
        German: 'German',
        English: 'English'
      },
      short_languages: {
        de: 'German',
        Deutsch: 'German',
        german: 'German',
        en: 'English',
        Englisch: 'English',
        english: 'English',
        fr: 'French',
        Französisch: 'French',
        sign: 'Signs'
      },
      levels: {
        1: 'All levels, including beginners',
        2: 'Advanced level, ideal for anyone who has held a brush before',
        3: 'Professional level, ideal for those with ArtNight or other painting experience',
        4: 'because it is needed on staging'
      },
      description_title: 'What {text} can expect',
      description_title_text: 'you',
      buy_group_booking: 'Request private group event',
      buy_gift_card: 'Gift idea? Give ArtNight',
      levels: {
        1: 'Easy',
        2: 'Advanced',
        3: 'Professional'
      },
      bundles: {
        title: "What's included?",
        title_parent: 'Also part of:',
        more_link: 'Learn more'
      },
      subtitles: {
        video_course: 'Contains {qty} video course | Contains {qty} video courses',
        artnight: 'Painting with acrylics',
        handlettering: 'Learn handlettering and brush lettering',
        'handlettering-pro': 'Learn advanced techniques for handlettering and brush lettering'
      },
      segmentation_label: {
        kompakt: 'Compact',
        compact: 'Compact',
        classic: 'Classic',
        premium: 'Premium'
      }
    }
  },
  theme: {
    seo_title: 'ArtNight: {theme} painting course',
    seo_description: 'Painting with ArtNight: The {theme} motif available in over 60 cities in Germany & Austria'
  },
  events: {
    seo_title: '{title} - ArtNight on {date}, {venue}',
    seo_online_title: '{title} - Online ArtNight on {date}',
    seo_description: 'On {date} at {time}, {host} will paint the motif {title} with you - {venue} in {city}',
    seo_online_description: 'On {date} at {time}, {host} will paint the motif {title} with you online',
    more_info: 'More info',
    back_to_events: 'Back to events',
    regular_upcoming_in: '{brand}s in ',
    upcoming_in: '{brand}s in',
    upcoming_in2: 'Upcoming {brand}s in',
    upcoming_in3: 'Upcoming {brand}s in',
    more_upcoming_in: '{brand}s in',
    upcoming: 'Upcoming {brand}s',
    upcoming_from: 'More {brand}s from',
    upcoming_online: 'More Online {brand}s',
    no_more_events: 'More events are being planned.',
    no_more_events_with_filters: 'Oops, there are no ArtNights with this selection.',
    upcoming_host: 'More motifs with host {host}',
    upcoming_city: 'More Artnights in {city}',
    no_results: 'No results found!',
    load_more: 'Show more',
    price_unit: '/ ticket',
    events_in: 'Painting courses in',
    nearby_you: 'near you',
    last_viewed: 'Last viewed'
  },
  venue: {
    label: 'The location',
    undefined_label: 'Location Pending',
    undefined_description:
      'We will share the exact location with you at the latest 48 hours before the event starts via email and here on the website. Your event will definitely take place in {city}!',
    upcoming_events: 'More {brand}s at this location',
    subtitle: 'Your location',
    open_map: 'Show on Google Maps',
    has_parking: 'Parking available',
    has_accessibility: 'Accessible for people with disabilities',
    type: 'Venue type (e.g. bar or restaurant)'
  },
  host: {
    label: 'Host',
    course_management: 'Course instructor',
    events_held_label: 'Events given',
    artnight_label: 'With your artist',
    search_host: 'Search for an artist',
    meet: 'Meet your host',
    know: 'get to know'
  },
  rebooking: {
    booking_number: 'Booking number',
    resend_booking_title: 'Request booking confirmation',
    resend_booking_subtitle:
      "Can't find your booking confirmation? Please enter your email address that you used for your booking and we will send you your booking confirmation in the next few minutes.",
    title: 'Ticket rebooking',
    subtitle: 'To change your booking, please enter your email address and order number.',
    reason_label: 'Tell us the reason for rebooking:',
    reason_placeholder: 'Reason for rebooking',
    info_line_1: 'Important information',
    info_line_2: 'Realtainment GmbH is legally not obligated to allow ticket rebooking*. ',
    info_line_3:
      'A rebooking is only possible as a courtesy up to <b>48 hours</b> before the event takes place. If you decide to rebook, you will receive a voucher code that you can use to book a new ArtNight. ',
    info_line_4: 'Details about our cancellation policy can be found {rebooking_link}.',
    info_line_5: '*Terms and Conditions of Realtainment GmbH',
    info_line_6: 'Further questions?',
    info_line_7: 'Feel free to contact our team via this {support_link}.',
    contact_form: 'Contact form',
    button_next: 'Next',
    button_back: 'Back',
    selection_title: 'Select tickets',
    selection_subtitle: 'Select the tickets you would like to rebook.',
    confirm_title: "Thank you. You're almost done!",
    confirm_subtitle: 'Please click the link in your cancellation confirmation to complete the process.',
    reason_title: 'Reason for rebooking',
    reason_subtitle:
      'Let us know why you need to rebook your tickets. Please note that this step is necessary to receive your vouchers.',
    thankyou_title: 'Rebooking confirmed',
    thankyou_subtitle:
      'Yipeee. You have just received an email from us to confirm your cancellation once more. Please also check your spam folder. After confirmation, you will immediately receive an email with your new voucher code.',
    warning_title: 'Please note',
    warning_text:
      'We will send you an email to confirm the rebooking of these tickets. Please click on the link in the email to receive your new vouchers.',
    warning2_title: 'Rebooking pending',
    warning2_text: 'Please check your emails to confirm this rebooking and receive vouchers for your next ArtNight.',
    reason_options: {
      corona: 'Coronavirus',
      illness: 'Illness',
      prevented: 'Schedule conflict',
      another_interest: 'Interest in another {brand}',
      order_mistake: 'Booking mistake',
      change: 'Change of time/date/location of the {brand}',
      other: 'Other'
    },
    email_success_thank_you: 'Thank you for your request!',
    email_success_text:
      'If we can find a booking with your email address, we will resend your order confirmation within a few minutes. If you do not receive an email, please check that your email address is correct and check your spam folder. If you have any questions, you can contact our customer service at any time:',
    help_and_contact: 'Help & Contact'
  },
  cancellations: {
    thankyou_text: 'Thank you for your feedback!'
  },
  cart: {
    title: 'Shopping cart',
    warning: 'Your tickets are reserved for 30 minutes.',
    open: 'Open shopping cart',
    button_text: 'Add to cart',
    price_per_item_text: 'Price per item',
    added_voucher_text: 'Applied voucher code',
    total_text: 'Total sum',
    subtotal_text: 'Subtotal',
    qty_text: 'Quantity',
    voucher_code_label: 'GIFT VOUCHER',
    empty_text: 'Your shopping cart is currently empty.',
    to_checkout_text: 'Proceed to checkout',
    continue_shopping_text: 'Continue shopping',
    pay_button: 'Pay',
    add_to_cart_text: 'Book now | Buy now',
    empty_cart_text: 'Your shopping cart is currently empty. Please add products before proceeding to checkout',
    qty_adjusted_text: 'The quantity has changed. Only {qty} tickets left!',
    sold_out: 'Sold out',
    not_available: 'Not available',
    remove_ticket: 'Remove',
    view_motiv: 'View theme',
    find_ticket: 'Find ticket'
  },
  coupons: {
    add_coupon_text: 'Do you have a voucher code? Click here!',
    add_coupon_info_text:
      "Discount promotions cannot be combined with other coupons. <br>Details about paying with vouchers can be found <a href='https://help.artnight.com/de/support/solutions/folders/42000106111' target='_blank'><u>here</u></a>.",
    input_placeholder: 'Enter code',
    success_text: 'Voucher code successfully applied.',
    error_text: 'The voucher code provided is not valid.',
    coupon_subtext:
      'Discount codes and voucher codes cannot be used to purchase a gift voucher. You can only use one discount code per order.'
  },
  checkout: {
    checkout_button: 'Proceed to checkout',
    title: 'Your shopping cart',
    order_as_company: 'Order as a company',
    payment_title: 'Payment method',
    billing_title: 'Personal details',
    order_title: 'Your order',
    order_button_submit: 'Submit order',
    free_order_button_submit: 'Submit order for free',
    select_payment_gateway: 'Select your preferred payment method',
    shop_more: 'I want to continue shopping',
    newsletter_check:
      'Subscribe to the newsletter and be informed about promotions, discounts, competitions and new dates.',
    terms_check: 'I have read and agree to the {link}. *',
    terms_link: 'Terms and Conditions',
    credit_card: 'Credit card',
    coupon_text: 'Enter voucher',
    email_text: 'This is where we will send your order confirmation.',
    select_payment_text: 'Select payment method',
    validation_failed: 'Please fill in the fields.',
    voucher_upsell: {
      text: 'If you wish, you can add a {brand} voucher to your order here.'
    },
    giftcard_warning: 'A gift voucher can be used for all products except for additional gift vouchers.',
    order: {
      number: 'Order number',
      email_text: 'Your email',
      email_info_text:
        'If you do not receive a confirmation email within 10 minutes after booking, please check all relevant email folders: Spam, Junk mail, Advertisements, etc.',
      invoice_details: 'Invoice recipient',
      title: 'Order',
      thankyou_text: 'Thank you! We have received your order.'
    },
    thank_you: {
      applied_coupon: 'Applied coupon',
      applied_voucher: 'Applied voucher code'
    },
    shipping_total: 'Processing and shipping fee',
    empty_cart_warning: 'You cannot create an order if there are no items in the shopping cart.'
  },
  form: {
    first_name: 'First name',
    last_name: 'Last name',
    name: 'Name',
    email: 'Email address',
    address: 'Street and house number',
    address_additional: 'Additional address',
    street: 'Street',
    street_number: 'Street and house number',
    number: 'House number',
    city: 'City',
    postcode: 'Postal code',
    country: 'Country',
    phone: 'Mobile number',
    company: 'Company name',
    tax_id: 'Tax identification number',
    notes: 'Notes',
    additional_information: 'Additional information',
    phone_notice: 'You will be informed about any changes to the {brand} via this number.',
    confirm: 'Confirm',
    participants: 'Participants',
    language: 'Language',
    start_time: 'Start time',
    separate_invoice: 'I need a separate invoice',
    phone_number: 'Phone number',
    birthday: 'Birthday',
    venue: {
      options: [
        {
          label: 'Yes, the venue is already fixed',
          value: 'have_venue'
        },
        {
          label: 'No, not yet',
          value: 'no_venue'
        }
      ]
    },
    validations: {
      required_field: 'Field is required',
      name_minlength: 'The name must have at least 2 letters.',
      valid_email: 'Please provide a valid email address.',
      valid_city: 'The city name you entered does not appear to be valid',
      valid_postcode: 'The postal code must have at least 3 letters.',
      valid_phonenumber: 'Please enter a valid phone number.',
      valid_tax_id: 'The tax number must consist of at least 3 letters.',
      numeric: 'This item should be a number.'
    }
  },
  payment: {
    processing: 'Processing order...',
    failed_title: 'Failed order',
    failed_text: 'The payment for order #%s from %s has failed. Please try again.',
    failed: {
      title: 'Payment failed',
      text: 'Unfortunately, we cannot complete your payment. Your shopping cart is saved for 30 minutes.',
      back_to_cart: 'Back to shopping cart',
      other_payment_method: 'to choose another payment method',
      contact_support_button: 'Contact support'
    },
    pending: {
      title: 'Payment processing',
      text: 'Please do not close or refresh the page. We are currently processing your payment.'
    },
    error: {
      updating_cart: 'Error updating shopping cart',
      payment_failed: 'Error in payment processing'
    }
  },
  footer: {
    constent_preferences: 'Cookie settings',
    customer_service: 'Customer service',
    offer: 'Offers',
    social_media: 'Social Media',
    countries: {
      de: 'Germany',
      ch: 'Switzerland',
      nl: 'Netherlands',
      uk: 'UK',
      at: 'Austria'
    },
    instagram_text:
      'Follow us on Instagram, tag your images with the hashtag {hashtag} and have a monthly chance to win a {brand} for 2 people and be reposted by us.',
    cookie_button_text: 'Accept',
    cookie_text:
      'This website uses cookies - for more information about this and your rights as a user, please see our Privacy Policy. Click "Accept" to accept cookies.'
  },
  newsletter: {
    footer_title: 'Newsletter',
    placeholder_email: 'Email',
    placeholder_city: 'Choose your city',
    button_submit_text: 'Submit',
    button_send_text: 'Sign up now',
    button_sent_text: 'Sent',
    widget_title: 'Follow us into the world of creative flows',
    event_sold_out_title: 'Waiting list',
    event_sold_out_text:
      'This ArtNight is currently fully booked. We will inform you as soon as there are new dates or free spots available.',
    artnight: {
      subscribed_text:
        'Almost done! You have just received an email - simply confirm your registration and receive ArtNight news!',
      homepage_text:
        'New events and offers? When will ArtNight finally come to your city? With the ArtNight newsletter, you will know immediately. Sign up now and get regular updates about new dates and great promotions!',
      thank_you_text:
        'You have successfully subscribed to our newsletter. Welcome to our ArtNight universe. From now on, exclusive discount codes, giveaways, and the hottest stuff around ArtNight await you. Let’s toast to that first!?'
    },
    footer_text: 'Sign up now and get regular updates about new dates and great promotions!',
    validations: {
      email: 'The entered email address is not correct.',
      required: 'Email is a required field.',
      city_required: 'City is a required field.'
    },
    landing: {
      title: 'Hooray, you’re in!',
      text_1: 'You have successfully subscribed to our newsletter. Welcome to our {brand} universe.',
      text_2:
        'From now on, exclusive discount codes, giveaways, and the hottest stuff around {brand} await you. Let’s toast to that first! ?'
    }
  },
  press: {
    reviews: 'What our community says',
    contact: 'Press contact',
    title: 'Press portal',
    title_section1: 'Press releases',
    title_section2: 'Press reviews',
    title_section3: 'Media downloads'
  },
  validations: {
    email: 'The entered email address is not correct.',
    required: 'Field is required',
    min_length: 'The field must contain at least {min} characters.',
    city: 'The city name you entered does not appear to be valid',
    postcode: 'The postal code must contain at least {min} characters.',
    tax_id: 'The tax ID must consist of at least {min} characters.'
  },
  event_attendee_registration_success: {
    registration: 'Your registration was successful!',
    confirmation_one: 'Please have this confirmation ready before your',
    confirmation_two: 'to show it to your workshop leader.',
    fun: 'We wish you lots of fun!'
  },
  event_attendee_registration: {
    headline: 'Please enter your name in our participant list!',
    no_events_found: 'Sorry, there are no events today.'
  },
  listings: {
    sort_by: 'Sort by:',
    video_courses: {
      hero_title: 'ArtNight video courses',
      hero_description:
        'With our new video courses, you have a wide variety of motifs to choose from, which you can paint at your own relaxed pace.',
      bundles_title: 'Bundles',
      bundles_description: 'Our video bundles: Buy thematically matching video courses together and save money!',
      courses_title: 'Individual video courses',
      bundles_courses_count: 'CONTAINS NO VIDEO COURSES | CONTAINS ONE VIDEO COURSE | CONTAINS {count} VIDEO COURSES'
    },
    sortings: {
      'slug:asc': 'Alphabetical, A-Z',
      'slug:desc': 'Alphabetical, Z-A',
      'price:asc': 'Price, low to high',
      'price:desc': 'Price, high to low',
      'created_at:asc': 'Date, old to new',
      'created_at:desc': 'Date, new to old'
    }
  },
  group_events: {
    head_title: 'ArtNight: Create your private group event',
    back_to_page: 'Back to overview',
    details: {
      location_sub: 'Please enter the address of the desired event location here',
      error_max_participants: '60'
    },
    options: {
      eventDateTime: '{date} at {time}',
      eventDate: 'Date',
      eventTime: 'Time',
      eventLocation: 'Location',
      locationCity: 'City',
      locationAddress: 'Address',
      locationPostalCode: 'Postal Code',
      locationContact: 'Contact',
      numberOfParticipants: 'Number of participants'
    },
    thank_you: {
      heading: 'Yay! Thank you for your booking.',
      subheading: 'We will get back to you with more information about your event.',
      back_to_home: 'Back to homepage',
      links: 'Do you have any questions? {email} or {phone}'
    },
    header: {
      title: 'Let’s plan your ArtNight – in just four steps!',
      subtitle:
        'We ask you a few questions to find the perfect ArtNight for your event. You can still change everything afterwards.',
      subtitle_v2: 'Organize your team event, private birthday party, or other creative celebrations with ArtNight'
    },
    participants: {
      title: '1 – Participants',
      subtitle: 'Up to {participants} people, the minimum price of {price} € remains',
      count: 'How many people will participate?',
      less_than_participants:
        'Are you fewer than {participants} people? You can also participate as a group at public ArtNights.',
      public_artnight_link: 'To the public ArtNights',
      more_than_participants:
        'For bookings over 25 people, we will gladly take care of your request individually. You can send it to us in the next step without obligation.'
    },
    location: {
      title: '2 – Location',
      subtitle_1: 'How would you like to hold your event?',
      subtitle_2: 'Where should your event take place?',
      subtitle_3: 'And in what kind of location?',
      options: {
        customer: 'Own premises'
      },
      cta: {
        title: 'Event on site',
        feature_line_1: 'All materials are provided by us',
        feature_line_2: 'Event at your location',
        button_selected: 'Selected',
        price: 'From {price}'
      },
      city_label: 'City',
      postcode_label: 'Postal code',
      telefonnummer_label: 'Phone number'
    },
    themes: {
      title: '3 – Motif selection',
      subtitle: 'Don’t worry: The motif can still be changed later if you change your mind.',
      details_modal_title: 'Information about the motif',
      modal_title: 'All ArtNight motifs ({count})',
      load_more_text: 'Browse all {count} motifs',
      description_title: 'What awaits you',
      details_text: 'Show details'
    },
    date_time: {
      title: '4 – Date & time',
      subtitle: 'Events requested less than 14 days in advance will be checked for feasibility.',
      time: 'At what time should your event take place?',
      flexible_time: 'We are flexible with the time',
      label: 'Time'
    },
    summary: {
      subtitle: 'Overview of your event',
      button_text: 'Continue to summary',
      button_short_text: 'To summary',
      total_text_with_tax: 'Total amount (incl. VAT)',
      participants_text: '{price} x {number} participants',
      total_text: 'Total amount'
    },
    footer: {
      button: 'Book your event'
    },
    banner: {
      text: 'But we also offer customized options.',
      sub_text: 'For <b>private groups</b> or <b>team events</b>.'
    },
    request: 'Request without obligation'
  },
  instagram: {
    title: 'Follow us for even more inspiration',
    link_text: 'To the ArtNight Instagram'
  },
  founder: {
    title: 'Aimie, Founder of ArtNight',
    text: '“ArtNight is a platform and a creative community that believes creativity is the key to a fulfilled life.”',
    ctaText: 'More about us',
    video_title: 'Experience exciting painting classes with ArtNight!'
  },
  offline_message: 'You are offline. Some features may not be available.',
  product_page: {
    title: {
      events: 'Painting classes near you | Paint {themeCategoryNames}',
      motiv: 'All categories | Paint {themeCategoryNames}',
      city: 'Painting classes in {city} | Paint {themeCategoryNames} in {city}',
      kids: 'Painting with kids'
    },
    sub_title: 'Choose a motif for your creative break'
  },
  auth: {
    register_success: 'Account confirmed! Log in to continue.',
    register_title: 'Create Account',
    register_subtitle: 'Create an ArtNight account to enhance your experience!',
    register_success_email: 'Please check your inbox to confirm your email address.',
    register_login: 'I already have an account',
    register_button: 'Create',
    register_confirmation: 'Email confirmed! Please log in.',
    field_first_name: 'First name',
    field_last_name: 'Last name',
    field_email: 'Email address',
    field_password: 'Password',
    field_current_password: 'Current password',
    field_new_password: 'New password',
    field_password_repeat: 'Repeat password',
    field_newsletter: 'Receive regular updates in our newsletter.',
    login_title: 'Login',
    login_subtitle: 'If you already have an ArtNight account, log in with your email address.',
    login_remember_title: 'Stay logged in',
    login_remember_subtitle: 'Save my login details for next time',
    login_button: 'Log in',
    logout_button: 'Log out',
    login_register_title: 'Register',
    login_register_subtitle: 'Create your ArtNight account now!',
    forgotten_password: 'Forgot password',
    login_register_list_1: 'Create and manage your wishlist for future purchases and gift ideas',
    login_register_list_2: 'Find all your orders in one overview',
    login_register_list_3: 'Receive our newsletter with updates on new products and special offers',
    forgot_password_title: 'Forgot password',
    forgot_password_subtitle: 'Enter your email address and we will send you a link to create a new password.',
    forgot_password_button: 'Send email',
    forgot_password_register_link: 'Create an account',
    forgot_password_help_title: 'Need help?',
    forgot_password_help_button: 'Contact support',
    forgot_password_help_subtitle:
      'If you have trouble logging in or remembering your email address, please contact our customer service.',
    reset_password_title: 'Reset password',
    reset_password_success_title: 'Password confirmed',
    reset_password_success_subtitle: 'Your password has been reset, please log in.',
    reset_password_subtitle: 'Create a new password for your ArtNight account.',
    menu_account: 'Account',
    menu_my_artnight: 'My ArtNight',
    menu_overview: 'Overview',
    menu_orders: 'Orders',
    menu_my_account: 'Edit account',
    menu_cs: 'Customer service',
    menu_rebooking: 'Ticket rebooking',
    menu_support: 'Contact customer service',
    menu_calendar: 'Calendar',
    overview_title: 'Account overview',
    overview_subtitle: 'Welcome to your personal ArtNight area!',
    no_order_history_title: 'No order history',
    no_order_history_subtitle: 'Please contact us if you are missing orders.',
    no_order_history_section: 'ArtNight account',
    not_logged_in_title: 'Please log in',
    not_logged_in_subtitle: 'Or register with your email address',
    edit_title: 'Edit account',
    edit_subtitle: 'View or change your ArtNight account.',
    orders_subtitle: 'View your ArtNight order history.',
    latest_order_section: 'Latest order',
    next_event_section: 'Next ArtNight',
    error_invalid_credentials: 'Error - Wrong password, please try again.',
    error_unconfirmed_email: 'User account is not verified',
    resend_confirmation_text: 'Resend confirmation email',
    error_sending_confirmation: 'There is a problem confirming your email, please contact our support team.'
  },
  account_edit: {
    title: 'Edit account',
    sub_title: 'View or change your ArtNight account',
    specification_title: 'Your details',
    password_title: 'Password',
    password_address: 'Address',
    buttons: {
      password: 'Change password',
      delete_account: 'Delete account',
      edit_user_data: 'Edit details',
      edit_address: 'Change address',
      save_changes: 'Save changes',
      save_new_password: 'Save new password'
    }
  },
  account_calendar: {
    date: 'Date',
    hour: 'Time',
    tickets: 'Tickets',
    host: 'Artist',
    place: 'Location',
    place_popup: {
      title: 'When will the event location be announced?',
      text: 'The venue is usually published at least one week in advance. 48 hours before the event starts, you will also receive another email with all the information and the exact address of the venue.'
    },
    modified: 'Modified',
    cancelled: 'Cancelled',
    order_cancel: 'Cancel order',
    past_events: 'Past ArtNights',
    view_order: 'View order details',
    to_calendar: 'Save to calendar',
    see_changes: 'View changes',
    subtitle: 'View all your ArtNight events',
    dropdown: {
      desc: 'Earliest to latest',
      asc: 'Latest to earliest'
    },
    inline_filters: {
      future: 'Upcoming',
      past: 'Past',
      all: 'All'
    },
    event_changes: {
      modified: 'Change',
      previous: 'Previous',
      current: 'Current',
      eventDuration: 'Duration',
      theme: 'Motif',
      venue: 'Venue',
      price: 'Price',
      level: 'Level'
    },
    show_all_events: 'Show all ArtNights'
  },
  order_history: {
    date: 'Order date'
  },
  order_details: {
    title: 'Order details',
    order_number_ua: 'Order number',
    order_date: 'Order date',
    tickets: 'Tickets',
    event_date: 'Event date',
    sold: 'Balance',
    deadline: 'Expiry',
    copy: 'Copy',
    copied: 'Copied',
    order_total: 'Subtotal',
    discount: 'Discount',
    giftcard: 'Gift card',
    paid_total: 'Total',
    payment_method: 'Payment method',
    order_number: 'Order confirmation',
    download_pdf: 'Download PDF',
    rebooking_ticket: 'Rebook these tickets',
    view_calendar: 'View calendar',
    quantity: 'Quantity',
    view_voucher: 'Voucher balance',
    available_voucher: 'Issued vouchers',
    avalaible_voucher_pdf: 'Gift voucher PDF',
    download_canceled_confirmation: 'Download cancelled confirmation',
    order_cancelled: 'Order cancelled',
    refunded_method: 'Refunded',
    close_button: 'Close'
  },
  product_listing: 'Show painting classes',
  thank_you_page: {
    title: 'Thank you!',
    subtitle: 'Your order was successful. You will receive an email confirmation shortly.',
    booking_summary: {
      title: 'Your ArtNight',
      subtitle: 'Download the event details to your calendar or make a note of the time and place of the event.',
      map_button: 'View in Google Maps',
      calendar_button: 'Add to calendar'
    },
    account: {
      title: 'Create account',
      subtitle: 'Your ArtNight events, order history & more.',
      already_registered: 'Already registered?',
      login: 'Log in now',
      create: 'Create'
    },
    voucher: {
      title: 'Your ArtNight voucher',
      subtitle:
        'You will receive the voucher card as a PDF by email. You can find the details of the voucher card in your ArtNight account.',
      button: 'Save PDF'
    },
    online_event: {
      subtitle:
        'Download the event details to your calendar. You will receive the Zoom link to participate in the ArtNight online event 24 hours before the start.',
      material_kit: '1x Material set'
    }
  },
  city_selector: {
    online_event: 'Online painting classes',
    all_cities: 'All ArtNight cities',
    search_host: 'Search for an artist'
  },

  group_booking_v2: {
    header: "Let's plan your ArtNight",
    participants: {
      title: 'Participants',
      subtitle: 'Up to 10 people, the minimum price of €490 remains',
      optional: 'Optional information',
      event_type: 'Event type',
      event_type_place_holder: 'Please select',
      options: {
        team_event: 'Team event',
        birthday: 'Birthday',
        summer_party: 'Summer party',
        bachelorette_party: 'Bachelorette party',
        xmas: 'Christmas party',
        other: 'Other'
      },
      language: 'Language of the event',
      notes: 'Note',
      notes_placeholder: 'Request a specific instructor or leave details about the location'
    },
    location: {
      title: 'Location',
      subtitle: 'Confirm the location details of your ArtNight',
      details: 'Location Details',
      field_name: 'Name of the venue',
      field_name_text:
        'If it is a private address, please provide the name on the doorbell here. If it is a café, restaurant or event location, please provide the name of the place.',
      premium_title: 'Premium Options',
      premium_option_text: 'ArtNight Partner',
      premium_text: 'We will find a suitable location from our partner portfolio for you!',
      city_text: 'My city is not listed',
      custom_city_text: 'Other city selected',
      modal_title: 'My city is not listed',
      modal_button: 'Submit request',
      modal_button_close: 'Cancel',
      modal_text:
        'If your city is not selectable, please send us a request!<br /><br />Our team will try to design the event for you and find some suitable artists.<br /><br />Please note that there will be a travel expense flat rate of approximately 1 EUR per kilometer.'
    },
    date_time: {
      title: 'Date & Time',
      subtitle: 'Select a date with 14 days advance notice',
      time_text: 'Please note that we will be on site one hour before and after the event.'
    },
    details: {
      title: 'Details',
      subtitle:
        'Please confirm the following information so that we can process your request for the private ArtNight.',
      title1: 'Contact person details',
      title2: 'Invoice details',
      field_email: 'Email address',
      field_phone: 'Mobile number',
      field_company: 'Company name',
      field_address: 'Billing address',
      field_postcode: 'Postal code',
      field_country: 'Country',
      field_vat_id: 'Tax ID',
      send_button: 'Send'
    },
    save_and_next: 'Save & Continue',
    total_cost: 'Total cost',
    pay_by_invoice: 'Pay by invoice',
    send_request: 'Send request',
    requested: {
      title: 'Great!',
      subtitle:
        'Thank you for your request! <br /><br />We will contact you within the next 2-3 business days!<br /><br /> If you have any questions in the meantime, please send an email directly to <a href="mailto:private-events@artnight.com">private-events@artnight.com</a>'
    },
    motiv: {
      title: 'Theme',
      subtitle: 'Choose a theme! The theme can be freely changed up to 7 days before the event.',
      select_later: {
        title: 'Decide later',
        subtitle: 'Book now and confirm the theme no later than 7 days before your ArtNight.',
        more_info: 'Learn more',
        popup_text:
          'You are welcome to select an acrylic theme for your ArtNight here. If you decide on a watercolor theme, please let us know directly when booking. Leave a message in the participants section.',
        popup_subtext: 'Upon request, we also offer XXL canvases.',
        motiv: 'Theme pending'
      },
      premium_option: {
        title: 'Premium Options',
        details: {
          opt1: 'Individual theme conception',
          opt2: 'Customized to your brand',
          opt3: 'We make every idea ArtNight-suitable and easy to paint for everyone'
        },
        wish_motiv: 'Custom theme',
        min_participants: 'Minimum 25 participants'
      },
      cancel: 'Cancel'
    }
  },
  feedback: {
    title: 'Share your feedback with us',
    comment: 'Your comment',
    steps: {
      one: {
        title: 'Theme',
        sub_title: 'Rate the difficulty and experience of the theme you created.',
        rating_title: 'How satisfied are you with your artwork?',
        improvement: 'What can we improve to make the theme even more achievable during the ArtNight?',
        options: {
          one: 'More time',
          two: 'Better guidance',
          three: 'More individual support',
          four: 'Better distribution of materials',
          five: 'Other'
        }
      },
      two: {
        title: 'Artist',
        sub_title: 'Please rate your experience with the artist, {value}.',
        rating_title: "How do you rate the artist's performance?",
        improvement: 'What can the artist improve in the future?',
        compliments: 'Tell the artist what you liked about the ArtNight'
      },
      three: {
        title: 'Location',
        sub_title: 'Tell us about your experience with the venue.',
        rating_title: 'How did you like the location?',
        improvement: 'What can the location improve to offer an even more relaxed ArtNight?',
        options: {
          one: 'Better lighting',
          two: 'Tables with more space',
          three: 'Better service',
          four: 'More food or drink options',
          five: 'Less noise',
          six: 'Better parking options',
          seven: 'Better connection to public transport',
          eight: 'Other'
        }
      }
    },
    thank_you:
      'Your feedback has been registered. If you have questions or would like to make changes, please contact the ',
    outdated_title: 'Oops',
    outdated_link: 'Your link has unfortunately expired. If you have feedback on this event, please contact the'
  },
  homepage: {
    hero: {
      text: 'Your experience. <br/> Your artwork.',
      cta: 'View current offers'
    },
    navigation_grid: {
      acryl: 'Acrylic painting courses',
      aquarell: 'Watercolor workshops',
      voucher: 'Buy voucher',
      kids: 'ArtNight Kids',
      online: 'Online painting course',
      group: 'Private groups'
    },
    popular_themes: {
      title: 'Popular themes',
      motiv: {
        structure: 'Structure Abstract',
        banksy: 'Banksy: Street Art Collection',
        spatula: 'Abstract work with the palette knife',
        inspiration: 'Abstract – Inspiration',
        glitter: 'Glitter Abstract',
        kids_eule: 'ArtNight Kids: Owl',
        partner: 'Paint your Partner',
        eule: 'Owl',
        layering: 'Abstract Layering',
        city_passenger: 'City walk',
        dancing: 'Dancer in the light',
        lyon: 'ArtNight Lion',
        wind: 'Gone with the Wind',
        aquarell_flower: 'Watercolor: Blossoms and Leaves',
        flowers: 'Flower wheel',
        under_water: 'Underwater World',
        monet: 'ArtNight Klassik: Monet - Seerosen',
        frida_acryl_collage: 'ArtNight Klassik: Frida Kahlo Acryl Collage',
        zuckerwatte_wolken: 'Zuckerwatte-Wolken',
        goldener_see: 'Goldener See'
      },
      cta: 'Discover more'
    },
    usps: {
      title: 'Why ArtNight?',
      options: {
        1: {
          title: 'ArtNight is for everyone',
          description: "Whether you've painted before or have never held a brush."
        },
        2: {
          title: 'Everything is prepared',
          description: 'You can expect a lovingly designed set-up including canvas, paints, brushes and apron'
        },
        3: {
          title: 'Your creative time out',
          description: 'Already over 1 million participants have rediscovered their creativity with ArtNight'
        }
      }
    },
    message: {
      text: '"We firmly believe that creativity is the key to a fulfilling life. The potential for it is within all of us. We just have to discover it."',
      signature: 'Aimie, Founder of ArtNight'
    },
    new_themes: {
      title: 'New ArtNight themes and experiences',
      motiv: {
        fruit: 'Pixel – Disco fruits',
        disco: 'Pixel – Disco ball',
        cat: 'ArtNight Kids: Grumpy Cat',
        sunrise: 'Tequila Sunrise',
        beat: 'ArtNight Beats',
        cliff: 'Coastal landscape – Cliffs',
        parc: 'Watercolor in the park',
        inspiration: 'Abstract - Inspiration',
        woman: 'Unter der Sonne des Südens',
        oranges: 'Paint and Frame: Orangen',
        lemons: 'Paint and Frame: Zitronen',
        oysters: 'The Art of Oyster Painting and Decoupage',
        kids: 'ArtNight Kids Aquarell: Kleine Monsterwerkstatt',
        winenpaint: 'Wine & Paint: Struktur Abstrakt',
        afro_beats: 'ArtNight Beats Afro Beats',
        frog: 'ArtNight Kids: Herr Frosch'
      },
      cta: 'View latest ArtNight themes'
    },
    city_select: {
      button: 'Select cities',
      title: 'Find ArtNights by cities',
      show_citie: 'Events in these cities',
      close: 'Close'
    },
    online_events: {
      title: 'Online painting courses for home',
      motiv: {
        poney: 'Pink Pony Club',
        frida: 'Frida Mocha Mousse',
        aquarell: 'Watercolor: Abstract',
        koi: 'Koi',
        partner: 'Paint Your Partner',
        flower: 'Flower wheel',
        sun: 'Under the Southern Sun',
        ski: 'Downhill in the snow',
        sommerwind: 'Sommerwind',
        lavender: 'Colorful Lavender',
        lemon_tree: 'Lemon Tree',
        la_dolce_vita: 'La Dolce Vita',
        vom_winde_verweht: 'Vom Winde verweht',
        wattwanderung: 'Wattwanderung',
        sternennacht: 'Sternennacht'
      },
      cta: 'View all online painting courses'
    },
    group_events: {
      title: 'Your private ArtNight',
      text: 'We bring ArtNight to your team event, bachelorette party or birthday celebration.'
    },
    how_it_works: {
      title: 'How ArtNight works',
      paragraphs: {
        find: {
          title: 'Discover',
          text: 'ArtNights take place daily in over 60 cities in Germany and Austria. Discover a variety of dates and experiences – and choose the event that suits you.',
          subtext:
            'Simply enter your <a href="/events" style="text-decoration: underline;">city</a> or browse through all available <a href="/motiv" style="text-decoration: underline;">themes</a> and get inspired.'
        },
        book: {
          title: 'Book',
          text: 'Secure your desired event with just a few clicks – and mark your creative time out directly in your calendar.',
          subtext:
            'Tip: Do you have an ArtNight <a href="/malkurs-gutschein" style="text-decoration: underline;">voucher</a>? You can redeem it at any time for your booking.'
        },
        create: {
          title: 'Experience',
          text: 'Your ArtNight is lovingly prepared by our artists – with everything you need. <br/> Arrive, immerse yourself in the creative experience and take your self-painted artwork home at the end.</br> Unforgettable memories included – whether alone, with friends or as a gift to yourself.',
          subtext: ''
        }
      }
    },
    events_category: {
      title: 'ArtNight Event Categories',
      options: {
        bestseller: 'Bestseller',
        abstract: 'Abstract',
        new: 'New arrivals',
        landscape: 'Landscapes',
        nature: 'Botany & Nature',
        people: 'People',
        animals: 'Animals',
        street: 'Pop & Street Art',
        limited: 'Limited Edition',
        specials: 'Specials',
        seasonal: 'Seasonal',
        kids: 'Kids',
        watercolor: 'Watercolor',
        classic: 'Classical Art',
        faces: 'Faces',
        symbols: 'Symbols',
        beats: 'Beats & Paint'
      }
    }
  },
  news_letter: {
    title: 'Your 10% Welcome Discount',
    text_part_one:
      'Sign up for the ArtNight newsletter, get up to 10% off your first booking, and be the first to hear about offers, new products, and contests! 💌',
    text_part_two:
      'After signing up, you will receive a confirmation email. The newsletter is free and you can unsubscribe at any time.',
    email_input: 'Email address',
    city_input: 'City',
    register: 'Sign up',
    success: 'Submitted'
  },
  theme_categories: {
    acryl: 'Acrylic Painting Classes',
    watercolor: 'Watercolor Workshops',
    voucher: 'Buy Voucher',
    kids: 'ArtNight Kids',
    online: 'Online Painting Class',
    group: 'Private Groups'
  },
  company: {
    title: 'COMPANY',
    about: 'About us',
    jobs: 'Jobs',
    press: 'Press',
    host: 'Become an artist',
    location: 'Become a venue'
  },
  support: {
    title: 'SUPPORT',
    help: 'Help & Contact',
    rebooking: 'Rebooking'
  },
  legal: {
    agb: 'Terms & Conditions',
    daten: 'Privacy Policy',
    impressum: 'Imprint',
    cookies: 'Cookie Settings'
  }
};
